import { Injectable } from '@angular/core';
import { ConfigService } from './services/config-service.service';

@Injectable({
  providedIn: 'root',
})
export default class BaseService {
  
  //public isProduction: boolean;
  //"https://itai.apphb.com/api/"
  //https://itai-net-core.azurewebsites.net/
  //"http://localhost:7070/api/";
  //https://localhost:7102/

  public baseUrl: string | undefined;

  constructor(private configService: ConfigService) {
  }

  initializeBaseUrl(
    baseUrlForDev: string,
    baseUrlForProd: string,
    environment: any
  ) {
    this.setBaseUrl(baseUrlForDev, baseUrlForProd, environment);
  }

  setBaseUrl(
    baseUrlForDev: string,
    baseUrlForProd: string,
    settings: any
  ): void {
;
    let locationHost: string = window.location.host;

    if (settings.production || !locationHost.includes('localhost')) {

      this.baseUrl = baseUrlForProd;

    } else {

      this.baseUrl = baseUrlForDev;
    }

  }

}
